export default __webpack_public_path__ + "locales/sk/Webhooks.json?hash=8dd321351068383d0066489381987412";